module.exports = __webpack_public_path__ + "ideal_en_paypal.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ideal_en_paypal.png
// module id = 632
// module chunks = 0